<template>
  <div id="Biodiversity">
    <div class="font">
      <span class="introSubTitle"><b>遥感生物多样性监测系统</b></span>
      <p class="textStyle">
        提出了遥感生态系统分类、森林植被类型分类制图方法，利用统计模型揭示生态系统重要特征参数分布与变化规律，并定量评估生态系统产水服务、土壤保持、水质净化等主要服务功能；研制了野生动物智能监测系统，开发管理和智能分析工具，集成红外相机影像动物识别算法，具备红外相机数据管理、生境管理、模型训练及动物活动数据智能化提取功能。实现基于遥感的生物多样性监测与生境质量评估，为生态环境监测与动物保护提供数据支持与决策依据。
      </p>

      <img
          width="100%"
          src="@/assets/img/scientific/biodiversity11.png"
      />
      <p class="img_figure">生态系统分类图及森林植被类型分类图</p>
      <img
          width="100%"
          src="@/assets/img/scientific/biodiversity2.png"
      />
      <p class="img_figure">野生动物智能监测系统</p>
<!--      <el-row :gutter="10">-->
<!--        <el-col :span="12">-->
<!--        </el-col>-->
<!--        <el-col :span="12">-->
<!--          <img-->
<!--              width="100%"-->
<!--              src="@/assets/img/scientific/Resource_apply-1.jpg"-->
<!--          />-->
<!--        </el-col>-->
<!--      </el-row>-->
    </div>
  </div>
</template>

<script>
// import myVideo from "../../node_modules/vue-video";

export default {
  data() {
    return {};
  },
};
</script>

<style lang="less">
#Biodiversity {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #454545;
  }
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
